import { render } from "./ChangePasswordComponent.vue?vue&type=template&id=58ce9b28&scoped=true"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=js"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=js"

import "./ChangePasswordComponent.vue?vue&type=style&index=0&id=58ce9b28&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ce9b28"]])

export default __exports__